// extracted by mini-css-extract-plugin
module.exports = {"containerRemarkModal":"styles_containerRemarkModal__Wlvbl","textRemarkContent":"styles_textRemarkContent__86c5o","textDealerName":"styles_textDealerName__e7X6i"};